import React from 'react';
import { Hero } from './components/Hero';
import { Problemas } from './components/Problemas';
import { Temas } from './components/Temas';
import { OpinionesGmail } from './components/OpinionesGmail';
import { Bonos } from './components/Bonos';
import { Comparativa } from './components/Comparativa';
import { Testimonios } from './components/Testimonios';
import { OfertaFinal } from './components/OfertaFinal';
import { Objeciones } from './components/Objeciones';
import { Soporte } from './components/Soporte';
import { PurchasePopup } from './components/PurchasePopup';
import { StickyCTA } from './components/StickyCTA';
import { useMetaPixel } from './lib/useMetaPixel';
import { BACKGROUND_IMAGE } from './lib/constants';
export function App() {
  useMetaPixel('1252242806993118');
  return <div className="relative min-h-full w-full bg-[#06181d]" data-id="element-0" data-mp="28u5z6q8t7bef">
      {/* Fondo: laboratorio de fisicoquímica desenfocado */}
      <div aria-hidden="true" className="fixed inset-0 z-0 bg-cover bg-center" style={{
      backgroundImage: `url(${BACKGROUND_IMAGE})`,
      filter: 'blur(10px)',
      transform: 'scale(1.1)'
    }} data-id="element-1" data-mp="23u9ueosaffxt" />
      <div aria-hidden="true" className="fixed inset-0 z-0 bg-[#06181d]/85" data-id="element-2" data-mp="3mj6jhwnqi0fz" />

      <main className="relative z-10 mx-auto w-full max-w-md" data-id="element-3" data-mp="3relwkmdx3sbc">
        <Hero data-id="element-4" data-mp="5ggje8nxyxz" />
        <Problemas data-id="element-5" data-mp="82ld64660ci" />
        <Temas data-id="element-6" data-mp="2zl3azit8d249" />
        <OpinionesGmail data-id="element-7" data-mp="2zllff2q1qmn9" />
        <Bonos data-id="element-8" data-mp="2zm4v0cs84yy4" />
        <Testimonios data-id="element-9" data-mp="2zmo5j8fjol24" />
        <Comparativa data-id="element-10" data-mp="2zng1ikd20ksx" />
        <OfertaFinal data-id="element-11" data-mp="33mf1dqjxhrdi" />
        <Objeciones data-id="element-12" data-mp="33lx0uhq8gqzs" />
        <Soporte data-id="element-13" data-mp="33n6zb810016y" />
      </main>

      <PurchasePopup data-id="element-14" data-mp="33oi1j3esp0vy" />
      <StickyCTA data-id="element-15" data-mp="38m1jadapbvsn" />
    </div>;
}